import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19ad42e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-product" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "dialog-footer" }

import { t } from '@/plugins/i18n'
import NewInputBatchSearch from '@/components/NewInputBatchSearch/index.vue'
import dblclick from '@/components/BatchSearch/index'
import { isJA } from '@/store'
import { reactive, ref, nextTick, watch, computed } from 'vue'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { shippingProductColumns, shippingProductColumnsEn, replenishmentProductColumns } from './data'
import { getCustomerProductSkuListApi } from '@/apis/inShipping'
import { clearForm } from '@/util/common'
import { debounce } from 'lodash'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'type', 'addList', 'countryCode'],
  emits: ['update:visible', 'getList'],
  setup(__props, { emit: emits }) {

const props = __props
 // type 1 国际发货 2 补货计划


const productTableConfig = {
  showSelection: true
}
const form = reactive({
  keywordSku: '',
  amazonKeywordSku: ''
})
const keyword = ref([])
const skuType = ref('')
const keywordSku = computed({
  get: () => props.type === 1 ? form.keywordSku : form.amazonKeywordSku,
  set: (v) => {
    if (props.type === 1) {
      form.keywordSku = v
    } else {
      form.amazonKeywordSku = v
    }
  }
})
watch(() => props.visible, (newValue) => {
  if (newValue) {
    skuType.value = props.type === 1 ? 'productSkus' : 'amazonMskus'
    keyword.value = []
    clear()
    getTableData()
  }
})
const tableLoading = ref(false)
const tableData = ref([])
const getTableData = () => {
  tableLoading.value = true
  const params:any = {
    goodsCountry: props.countryCode ?? 'CN'
  }
  if (skuType.value && keyword.value?.length > 0) {
    params[skuType.value] = keyword.value
  }
  getCustomerProductSkuListApi(params).then((res: any) => {
    if (res.success) {
      tableData.value = (res.data || []).filter((e: any) => e.useable && props.addList.findIndex((v:any) => v.shopProductSku === e.shopProductSku) === -1)
      console.log(tableData.value)
    }
  }).finally(() => { tableLoading.value = false })
}

let selectionList: any[]
const handleSelection = (val: any[]) => {
  selectionList = val
}

const STableRef = ref()
const clear = () => {
  selectionList = []
  clearForm(form)
}
const submit = debounce(() => {
  emits('getList', selectionList)
  emits('update:visible', false)
}, 500)

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('update:visible', false))),
    draggable: ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(submit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('添加商品')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form, {
            inline: true,
            model: _unref(form)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: skuType.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((skuType).value = $event)),
                    style: {"width":"140px","height":"40px"},
                    class: "select-sku"
                  }, {
                    default: _withCtx(() => [
                      (__props.type === 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_option, {
                              label: _unref(t)('平台SKU'),
                              value: "productSkus"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('客户商品SKU'),
                              value: "customerProductMskus"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('海外仓sku'),
                              value: "overseaProductSkus"
                            }, null, 8, ["label"])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_el_option, {
                              label: _unref(t)('平台SKU'),
                              value: "productSkus"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('Amazon sku'),
                              value: "amazonMskus"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('FNSKU'),
                              value: "amazonFnskus"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('ASIN'),
                              value: "amazonAsins"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('海外仓sku'),
                              value: "overseaProductSkus"
                            }, null, 8, ["label"])
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(NewInputBatchSearch, {
                    modelValue: keyword.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((keyword).value = $event)),
                    placeholder: _unref(t)('双击批量搜索'),
                    style: {"width":"230px"},
                    class: "order-item-input"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: getTableData
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _withDirectives(_createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
            STableRef.value = _value
          },
          "table-data": tableData.value,
          columns: __props.type === 1 ? _unref(isJA)()?_unref(shippingProductColumns):_unref(shippingProductColumnsEn) : _unref(replenishmentProductColumns),
          showPagination: false,
          "table-config": productTableConfig,
          "max-height": "480",
          onSelectionChange: handleSelection
        }, {
          productMainImg: _withCtx(({row}) => [
            _createVNode(ShoppingPreview, {
              image: row.productSkuImg || row.productMainImg || ''
            }, null, 8, ["image"])
          ]),
          productSkuInfo: _withCtx(({row}) => [
            _createElementVNode("p", null, _toDisplayString(row.productSku ?? ''), 1),
            _createElementVNode("p", null, _toDisplayString(row.productTitle ?? ''), 1),
            _createElementVNode("p", null, _toDisplayString(row.productPropertiesName ?? ''), 1)
          ]),
          amazonMsku: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row.amazonMsku ?? '') + "/" + _toDisplayString(row.amazonProductTitle ?? ''), 1)
          ]),
          amazonFnsku: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row.amazonFnsku ?? '') + "/" + _toDisplayString(row.amazonAsin ?? ''), 1)
          ]),
          _: 1
        }, 8, ["table-data", "columns"]), [
          [_directive_loading, tableLoading.value]
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})